module.exports = __webpack_public_path__ + "d3579c696da7239e0830d5dda6b4e2b4.svg";